/**
 * 创建埋点数据
 * @export
 * @param {React.Component} this
 * @param {string} tag
 * @return {*}
 */
export function latag(this: React.Component, tag: string) {
  // const str = lodash.compact(['', tag]).join('_');
  return `latag_pc_${tag}`;
}
